<template>
  <v-text-field
    outlined
    :value="value"
    :label="model.title"
    :error-messages="error"
    :disabled="disabled"
    :hide-details="config.hideDetails || false"
    :readonly="readonly"
    :dense="config.dense || false"
    @input="$emit('input', $event)"
    :autofocus="model.autofocus || false"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
  />
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import { nanoid } from "nanoid";
export default {
  // mixins: [modelOptions],
  props: {
    value: [String, Number],
    values: Object,
    model: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    config: { type: Object, default: {} },
  },
  data() {
    return {};
  },
  created() {
    this.fetchData();
  },
  computed: {
    readonly() {
      if (this.config?.readonly || this.model?.readonly) return true;
      return false;
    },
    val: {
      get() {
        let v = this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  methods: {
    async fetchData() {
      //if (this.val === undefined) this.val = Math.random().toString(36).substr(2, 4) + Date.now().toString(36); //uuidv4();
      //if (this.val === undefined) this.val = Math.random().toString(36).substr(2, 8) + "_" + Date.now().toString(36); //uuidv4();
      if (!this.value) this.val = nanoid(8);
    },
  },
};
</script>
